import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/BillOfLading/components/SectionParties/SectionParties.module.scss';

const cn = classNames.bind(styles);

const SectionParties = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__heading-box')}>
          <h2 className={cn('about__heading')}>
            Key Parties Involved in a Bill of Lading
          </h2>
          <p className={cn('about__heading-description')}>
            Three people are directly connected to a Bill of Lading for any and all shipments:
          </p>
        </div>

        <div className={cn('about__paragraphs')}>
          <p className={cn('about__paragraph')}>
            The shipper is the entity providing the goods for transport. They handle the packing and
            preparation of the shipment, which could be a supplier or your own warehouse or
            manufacturing facility.
          </p>
          <p className={cn('about__paragraph')}>
            The carrier is the entity responsible for moving the cargo, such as Maersk or any other shipping
            line, trucking company, or airline.
          </p>
          <p className={cn('about__paragraph')}>
            The <Link href='/freight-dictionary/consignor-consignee'>consignee</Link> is the designated recipient of the shipment, which could be your company or a
            manufacturer that requires the parts or products you are shipping.
          </p>
          <p className={cn('about__paragraph')}>
            The Bill of Lading serves as evidence of the contract of carriage between both the shipper and
            the carrier. In addition to these three main parties, a freight forwarder may also be involved in
            issuing or handling the Bill of Lading, especially in international or multimodal shipments.
          </p>
          <p className={cn('about__paragraph')}>
            The Bill of Lading must be signed by an authorized representative of the carrier, shipper, and
            consignee to be valid.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionParties;